<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lSOKCA/tc-custom/9781459248151.jpg?1728851764913" alt="This image is the cover for the book Open Doors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Open Doors
      </h1>
      <p class="bookDescription body article font2">
        <b>Family is complicated. Love isn’t.</b><br/><br/>Acclaimed artist Elaine Gordon can’t believe her loving husband is gone. After a lifetime spent utterly devoted to her soul mate and their marriage, Elaine is now tetherless, faced with widowhood and all the decisions that come with it, not least of which is what to do with her rambling, now-empty family home.<br/><br/>Anxious to console their mother in her time of grief, Elaine’s four grown children urge her to put everything on hold and spend some healing time with them. But visiting each unique and complicated child opens Elaine’s eyes to the fact that the children she raised have become adults she hardly knows: Sarah, who abandoned Western life for an orthodox enclave in Jerusalem; Lisa, Sarah’s accomplished twin and polar opposite, who will do anything for a child of her own; Peter, trapped in a hollow marriage in California; and Denis, the youngest, who just wants Elaine to accept his gay lifestyle.<br/><br/>As Elaine tries to bridge the physical and emotional miles, her eyes are opened to the startling truths of her own family, and what she must do to come to terms with her kids’ livesand a future that’s completely, wonderfullyhers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gloria Goldreich
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1eb9e41d